import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@codeandweb/ngx-translate';
import { AppService } from '../services/app.service';
import { LocalStorageService } from '../services/localStorage.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone: true
})
export class App implements OnInit {
  private translateService = inject(TranslateService);
  private appService = inject(AppService);
  private localStorageService = inject(LocalStorageService);

  ngOnInit(): void {
    this.translateService.addLangs(['ko', 'en', 'ja', 'fr']);
    const localLanguage = this.localStorageService.getLanguageInfo();

    if (localLanguage) {
      this.translateService.setDefaultLang(localLanguage);
      this.appService.usedLanguage.set(localLanguage);
    } else {
      const defaultLanguage = this.appService.getDefaultLanguage();
      this.appService.usedLanguage.set(defaultLanguage);
      this.translateService.setDefaultLang(defaultLanguage);
      this.localStorageService.setLanguage(defaultLanguage);
    }
  }
}
